module.exports = __webpack_public_path__ + "static/yum_intro_image-8c81da83005a862be47d9ba60e3b7c10.png";